module.exports = __webpack_public_path__ + "img/生涯研学.ca50367a.jpg";